// cropOptions.js
export const cropOptions = [
        "Alfalfa - Forage",
        "Alfalfa - Seed",
        "Barley - Grain",
        "Barley - Malt",
        "Barley - Silage",
        "Dry Beans",
        "Canola - Argentine",
        "Canola - Polish",
        "Corn",
        "Flax",
        "Dry Peas",
        "Potatoes",
        "Sugar Beets",
        "Sunflowers",
        "Wheat - Spring",
        "Wheat - Durum",
        "Wheat - Soft",
        "Other",
      ];